import { Component, Input, OnInit } from '@angular/core';
import {CautionStatus, PatientStatus} from 'src/app/helpers/enums';
import {IPatientWithStatus} from './patient-name.models';

@Component({
    selector: 'app-patient-name',
    templateUrl: 'patient-name.component.html',
    styleUrls: ['patient-name.component.scss']
})
export class PatientNameComponent implements OnInit {
    @Input() patient: IPatientWithStatus;
    nameClass: string;

    ngOnInit() {
        if (this.patient.patientStatus && this.patient.patientStatus !== PatientStatus.Active) {
            this.nameClass = this.patient.patientStatus;
        } else if (this.patient.cautionStatus === CautionStatus.Caution) {
            this.nameClass = CautionStatus.Caution;
        }
    }
}
